module.exports = __webpack_public_path__ + "assets/img/en-7aff7d2e.png";